export default "__VITE_ASSET__Ci_AvX_U__"